import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, TreeComponent } from '@xanadu/core';
import { Node, Group, User, Branch } from '@xanadu/model';
import { NodeModel } from '@xanadu/model';
import { Observable } from 'rxjs';
import { UserMenuBuilder } from '@xanadu/menu';

@Component({
    selector: 'app-user-tree',
    templateUrl: './user-tree.component.html',
    styleUrls: ['./user-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('user-tree')
export class UserTreeComponent extends TreeComponent<User | Group> {
    menuBuilder = inject(UserMenuBuilder);

    protected override get nodeType(): string | undefined {
        return 'user';
    }

    onGroup() {
        const group = new Group(undefined);
        group.name = 'new group';
        this.addChild(group);
    }

    onUser() {
        const user = new User(undefined);
        user.name = 'new user';

        this.addChild(user);
    }

    onPaste() {
        this.paste();
    }

    protected dropOk(dragModel: NodeModel, dropModel: NodeModel): boolean {
        const dragNode = dragModel.node;
        const dropNode = dropModel.node as Branch;

        return dragNode.fit(dropNode);
    }

    protected replace(node: Node, branch: Branch): Observable<User | Group> {
        return this.dataService.replace<User | Group>(node as any, branch);
    }
}
